import { Tag, TagLabel } from "@chakra-ui/react";

type Variant =
  | "outstanding"
  | "partial"
  | "paid"
  | "covered_insurance"
  | "covered_membership"
  | "insurance_pending"
  | "no_charge"
  | "returned"
  // A state the app does not know yet (memberships audit C37).
  | "neutral";

const STYLES: Record<Variant, { bg: string; color: string }> = {
  outstanding:         { bg: "#fee4e2", color: "#b42318" },
  partial:             { bg: "#fef0c7", color: "#b54708" },
  paid:                { bg: "#dcfae6", color: "#067647" },
  covered_insurance:   { bg: "#eaecf0", color: "#475467" },
  covered_membership:  { bg: "#d1fadf", color: "#027a48" },
  insurance_pending:   { bg: "#dbeafe", color: "#1d4ed8" },
  no_charge:           { bg: "#f2f4f7", color: "#344054" },
  returned:            { bg: "#f2f4f7", color: "#344054" },
  neutral:             { bg: "#f2f4f7", color: "#344054" },
};

export const StatusPill = ({
  variant,
  children,
}: {
  variant: Variant;
  children: React.ReactNode;
}) => {
  const s = STYLES[variant];
  return (
    <Tag size="sm" bg={s.bg} color={s.color} borderRadius="full" px="2.5" py="1" fontWeight="500" fontSize="12px">
      <TagLabel>{children}</TagLabel>
    </Tag>
  );
};
